/*
 *
 * Workspace admin reducers
 *
 */

import keyBy from 'lodash/keyBy';
import { fromJS } from 'immutable';
import { UNSET_CURRENT_USER } from 'data/CurrentUser/constants';
import * as constants from './constants';

const initialAccountsState = fromJS({
  accounts: null,
});

const initialTeamsState = fromJS({
  teams: null,
  team: {},
});

function workspaceAccountReducer(state = initialAccountsState, action) {
  switch (action.type) {
    case constants.ADD_ACCOUNT: {
      const { account } = action;
      const accountById = {
        [account.accountId]: account,
      };

      return getUpdatedStateWithAccount(state, accountById);
    }
    case constants.ADD_ACCOUNTS_LIST: {
      const { accounts } = action;
      const accountsById = keyBy(accounts, 'accountId');

      return state.setIn(['accounts'], accountsById);
    }
    default:
      return state;
  }
}

const workspaceTeamsReducer = (state = initialTeamsState, action) => {
  switch (action.type) {
    case constants.SET_TEAM_LIST:
      return state.setIn(['teams'], action.teams);
    case constants.SET_TEAM_ACCOUNTS:
      return getUpdatedStateWithTeam(state, action.teamId, { accounts: action.accounts });
    default:
      return state;
  }
};

const initialWorkspacesState = fromJS({
  workspaces: undefined,
  workspace: {},
  loading: undefined,
});

const workspaceWorkspacesReducer = (state = initialWorkspacesState, action) => {
  switch (action.type) {
    case constants.ADD_WORKSPACES_LIST:
      return state.setIn(['workspaces'], action.workspaces);
    case constants.ADD_WORKSPACE: {
      const { workspace } = action;

      return getUpdatedStateWithWorkspace(state, workspace);
    }
    case constants.SET_WORKSPACE_COLLABORATORS:
      return state.updateIn(['workspace', action.workspaceId], (item) => ({
        ...item,
        collaborators: action.collaborators,
      }));
    case constants.WORKSPACE_LOADING:
      return state.setIn(['loading'], action.loading);
    case constants.SET_SELECTED_WORKSPACE:
      return state.set('selectedWorkspace', action.selectedWorkspace);
    case UNSET_CURRENT_USER:
      return initialWorkspacesState;
    default:
      return state;
  }
};

const getUpdatedStateWithTeam = (state, teamId, teamToUpdate) => {
  const existingTeam = state.getIn(['team', teamId]);
  const updatedTeam = { ...existingTeam, ...teamToUpdate };
  return state.setIn(['team', teamId], updatedTeam);
};

export const getUpdatedStateWithAccount = (state, accountToUpdate) => {
  const existingAccount = state.getIn(['accounts']);
  const updatedAccount = { ...existingAccount, ...accountToUpdate };

  return state.setIn(['accounts'], updatedAccount);
};

export const getUpdatedStateWithWorkspace = (state, workspaceToUpdate) => {
  const existingWorkspaces = state.getIn(['workspaces']) || [];
  const updatedWorkspace = [...existingWorkspaces, workspaceToUpdate];

  return state.setIn(['workspaces'], updatedWorkspace);
};

const statusFilterToKey = {
  REVIEW: 'review',
  COMPLETE: 'complete',
  DENY: 'deny',
};

const initialRequestAccessState = fromJS({
  review: [],
  complete: [],
  deny: [],
  loaded: { review: false, complete: false, deny: false },
});

const workspaceRequestAccessReducer = (state = initialRequestAccessState, action) => {
  switch (action.type) {
    case constants.SET_REQUEST_ACCESS_REQUESTS: {
      const key = statusFilterToKey[action.statusFilter];
      if (!key) return state;
      return state
        .set(key, fromJS(action.requests || []))
        .setIn(['loaded', key], true);
    }
    case constants.SET_REQUEST_ACCESS_LOADED: {
      const { review, complete, deny } = action.payload || {};
      let next = state;
      if (review !== undefined) next = next.setIn(['loaded', 'review'], review);
      if (complete !== undefined) next = next.setIn(['loaded', 'complete'], complete);
      if (deny !== undefined) next = next.setIn(['loaded', 'deny'], deny);
      return next;
    }
    default:
      return state;
  }
};

export default {
  workspaceAccounts: workspaceAccountReducer,
  workspaceTeams: workspaceTeamsReducer,
  workspaceWorkspaces: workspaceWorkspacesReducer,
  workspaceRequestAccess: workspaceRequestAccessReducer,
};
